import { useEffect, useState } from "react"
import { FaEllipsis, FaPlus } from "react-icons/fa6"
import { useNavigate } from "react-router-dom"
import axios from "axios"
import api from "../config/backend"
import { SpinnerCircular } from "spinners-react"
import { toast } from "react-toastify"
import { IoPersonSharp } from "react-icons/io5"
import { FaPhoneAlt } from "react-icons/fa"
import { MdEmail } from "react-icons/md"
import "./css/CustomersList.css"
import DefaultProfile from "../assets/DefaultProfile.jpg"

// Calculate total amount of a quote
const calculateQuoteTotal = (quote) => {
    let total = 0

    const items = quote.items

    items.forEach(item => {
        total += (item.quantity * item.rate)
    })

    const subtotal = total

    if (quote.discount) {
        if (quote.discount.ispercentage) {
            total = total - (total * quote.discount.value / 100)
        } else {
            total = total - quote.discount.value
        }
    }

    if (quote.adjustment) {
        total = total + quote.adjustment.value
    }

    let tax = 0

    if (quote.taxdetails) {
        tax = total * quote.taxdetails.rate / 100
    }

    total = total + tax

    return { total, subtotal }
}

// Calculate total amount of a invoice
const calculateInvoiceTotal = (invoice) => {
    let total = 0

    const items = invoice.items

    items.forEach(item => {
        total += (item.quantity * item.rate)
    })

    const subtotal = total

    if (invoice.discount) {
        if (invoice.discount.ispercentage) {
            total = total - (total * invoice.discount.value / 100)
        } else {
            total = total - invoice.discount.value
        }
    }

    if (invoice.adjustment) {
        total = total + invoice.adjustment.value
    }

    let tax = 0

    if (invoice.taxdetails) {
        tax = total * invoice.taxdetails.rate / 100
    }

    total = total + tax

    return { total, subtotal }
}

const CustomersList = ({ customersList, setCreateCustomer }) => {
    const [activeCustomer, setActiveCustomer] = useState(0)
    const [invoices, setInvoices] = useState([])
    const [quotes, setQuotes] = useState([])

    const navigate = useNavigate()

    const token = localStorage.getItem("_crm__token")

    const customerDetails = customersList ? customersList[activeCustomer] : undefined

    const fetchInvoices = async () => {
        const { data, status } = await axios.post(`${api}/Accounting/invoices-list`, { token, customer: customerDetails.hash })

        if (data.success) {
            setInvoices(data.invoices)
        }
    }

    const fetchQuotes = async () => {
        const { data, status } = await axios.post(`${api}/Accounting/quotes-list`, { token, customer: customerDetails.hash })

        if (data.success) {
            setQuotes(data.quotes)
        }
    }

    useEffect(() => {
        fetchInvoices()
        fetchQuotes()
    }, [activeCustomer])

    return (
        <div className="_7fzc _8hqu">
            <div className="sidebar app-new-quotes-sidebar">
                <div className="header">
                    <div className="all-qutoes">
                        <h3>All Customers</h3>
                    </div>
                    <div className="hatchet-scab">
                        <button onClick={() => setCreateCustomer(true)}><FaPlus /> New</button>
                        {/* <div>
                            <FaEllipsis />
                        </div> */}
                    </div>
                </div>
                <div className="reacting-eggs">
                    {customersList.map((customer, index) => {
                        return (
                            <div
                                key={index}
                                className={activeCustomer === index ? "stubby-hex active" : "stubby-hex"}
                                onClick={() => setActiveCustomer(index)}
                            >
                                <div className="spinner-them">
                                    <div className="customer-name" style={{ color: "rgb(42, 42, 42)" }}>{customer.firstname} {customer.lastname}</div>
                                    <div className="customer_inr">{customer.currency.code}</div>
                                </div>
                                <div style={{ display: "flex", gap: "4px", fontSize: "12px" }}>
                                    <div style={{ display: "flex", alignItems: "center", gap: "4px", borderRight: "1px solid grey", paddingRight: "5px" }}>
                                        <FaPhoneAlt />
                                        {customer.phone}
                                    </div>
                                    <div className="custome_egg_emails" style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                        <MdEmail style={{ width: "16px", height: "16px" }} />
                                        {customer.email}
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
            <div className="squiffed-dint">
                {/* <div className="header">
                    {customerDetails.firstname} {customerDetails.lastname}
                </div> */}
                <div className="settings">
                    <div onClick={() => navigate("/accounting/customers/edit/" + customersList[activeCustomer].hash)}>Edit</div>
                </div>
                <div className="drape-cop">
                    {customerDetails ? (
                        <div className="riblike-gear">
                            <div className="cooked-sag">
                                <div className="wipes-care">Customer Details</div>
                                <div className="stood-you">
                                    <div className="ergon-two">
                                        <div>
                                            <img src={DefaultProfile} />
                                        </div>
                                        <div className="unites-pout">
                                            <div className="customer-deatils" style={{ color: "rgb(42, 42, 42)", fontWeight: 600 }}>
                                                {customerDetails.firstname} {customerDetails.lastname}
                                                {customerDetails.external && <span style={{ fontSize: "10px", fontWeight: 400, backgroundColor: "grey", color: "white", borderRadius: "2px", padding: "2px 4px", marginLeft: "10px" }}>External</span>}
                                            </div>
                                            <div className="customerDetails_email">
                                                {customerDetails.email}
                                            </div>
                                            <div className="customerDetails_phone" style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                <FaPhoneAlt />
                                                {customerDetails.phone}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="catkins-roar">
                                        <h4>Address</h4>
                                        <div className="misgrew-oryx">
                                            <span>Street</span>
                                            <span>{customerDetails.address.street}</span>
                                        </div>
                                        <div className="misgrew-oryx">
                                            <span>Alternate Street</span>
                                            <span>{customerDetails.address.streetone}</span>
                                        </div>
                                        <div className="misgrew-oryx">
                                            <span>City</span>
                                            <span>{customerDetails.address.city}</span>
                                        </div>
                                        <div className="misgrew-oryx">
                                            <span>State</span>
                                            <span>{customerDetails.address.state}</span>
                                        </div>
                                        <div className="misgrew-oryx">
                                            <span>Pin Code</span>
                                            <span>{customerDetails.address.zipcode}</span>
                                        </div>
                                    </div>
                                    <div className="catkins-roar">
                                        <h4>Currency</h4>
                                        <div className="misgrew-oryx">
                                            <span>{customerDetails.currency.name}</span>
                                            <span>{customerDetails.currency.code}</span>
                                            <span className="currency_list">{customerDetails.currency.icon}</span>
                                        </div>
                                    </div>
                                    <div className="catkins-roar">
                                        <h4>Information</h4>
                                        <div className="misgrew-oryx">
                                            <span>PAN</span>
                                            <span>{customerDetails.pancard}</span>
                                        </div>
                                        {customerDetails.customfields.map(field => {
                                            return (
                                                <div className="misgrew-oryx">
                                                    <span>{field.fieldname}</span>
                                                    <span>{field.value}</span>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                            <div className="swerved-boo">
                                <div className="zittern-rat">
                                    Quotes
                                    <span className="currency_list">{quotes.length}</span>
                                </div>
                                <div className="aniseed-qats">
                                    {quotes.length ? (
                                        quotes.map(item => {
                                            const { total, subtotal } = calculateQuoteTotal(item)

                                            return (
                                                <div className="lives-team" onClick={() => navigate(`/accounting/quotes?hash=${item.hash}`)}>
                                                    <div className="zarfs-kays">
                                                        <div className="pliancy-gym">QT-{String(item.quoteindex).padStart(6, "0")}</div>
                                                        <div>{item.customer.currency.icon + " " + total}</div>
                                                    </div>
                                                    <div className="lichen-ewer">
                                                        <div>{new Date(item.quotedate).toDateString()}</div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    ) : "No quote generated"}
                                </div>
                            </div>
                            <div className="swerved-boo">
                                <div className="zittern-rat">
                                    Invoices
                                    <span className="currency_list">{invoices.length}</span>
                                </div>
                                <div className="aniseed-qats">
                                    {invoices.length ? (
                                        invoices.map(item => {
                                            const { total, subtotal } = calculateInvoiceTotal(item)

                                            return (
                                                <div className="lives-team" onClick={() => navigate(`/accounting/invoices?hash=${item.hash}`)}>
                                                    <div className="zarfs-kays">
                                                        <div className="pliancy-gym">INV-{String(item.invoiceindex).padStart(6, "0")}</div>
                                                        <div>{item.customer.currency.icon + " " + total}</div>
                                                    </div>
                                                    <div className="lichen-ewer">
                                                        <div>{new Date(item.invoicedate).toDateString()}</div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    ) : "No invoice generated"}
                                </div>
                            </div>
                        </div>
                    ) : undefined}
                </div>
            </div>
        </div>
    )
}

export default CustomersList
